import getColor from '../bullet-bar/get_color.js'
import '../close-button.tag'

riot.tag2('city-infobox', '<close-button if="{data}" onclick="{close}"></close-button> <h3 class="infobox__title">{data.name}</h3> <p>Klicke auf eine Messstation, um ihre Nitrat-Werte zu sehen.</p> <ul class="city-infobox__station-list"> <li each="{station in data.measurements}" class="city-infobox__station" riot-style="background-color:{getColor(station.value)};" onclick="{onClick}"> {station.mstbez} </li> </ul>', '', 'if="{data}" class="infobox city-infobox {-visible: visible}"', function(opts) {

  this.data = false
  this.visible = false
  this.getColor = getColor

  riot.control.on(riot.EVT.updateCityInfobox, data => {
    this.update({data, visible: true})
  })

  riot.control.on(riot.EVT.hideCityInfobox, () => {
    this.update({visible: false})
  })

  this.close = () => {
    riot.control.trigger(riot.EVT.hideCityInfobox)
  }

  this.onClick = e => {
    this.close()
    riot.control.trigger(riot.EVT.updateStationInfobox, e.item.station)
  }

});



// WEBPACK FOOTER //
// ./src/components/city-infobox/city-infobox.tag